import {Route} from 'vue-router'
import {Message} from 'element-ui'
import router from './index'
import setting from '@/setting'
import {IUserInfo} from '@/@types/global'

// const whiteList = ['/login', '/regist']
router.beforeEach((to: Route, from: Route, next: Function) => {
  const title = to.meta?.title
  document.title = title ? title + ' · ' + setting.MAIN_TITLE : setting.MAIN_TITLE

  const temp = localStorage.getItem('userInfo')
  let role = 2
  let userInfo: IUserInfo = {}
  if (typeof temp === 'string') {
    userInfo = JSON.parse(temp)
  }
  role = userInfo.roleID || 2
  if (role === 1 || role === 3 || (role === 2 && to.meta?.role !== 1) || role === 4) {
    next()
  } else {
    Message({
      message: '无权访问！',
      type: 'error',
      duration: 2000,
      onClose: function () {
        next(from.path)
      }
    })
  }
})
